import axios from 'axios';

export const getApplicationMetrics = async () => {
    const { data } = await axios.get('/api/metrics/application');
    return data;
};

export const getRedisCacheStatus = async () => {
    const { data } = await axios.get('/api/cache/redis/status', {
        headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0',
        },
    });
    return data;
};

export const testRedisCache = async () => {
    const { data } = await axios.post('/api/cache/redis/test', {});
    return data;
};

export const getDbSlowQueries = async () => {
    const { data } = await axios.get('/api/metrics/db/slow-queries');
    return data;
};

export const runDbExplain = async ({ type, programName, snapshotDate }) => {
    const payload = { type, programName, snapshotDate };
    const { data } = await axios.post('/api/metrics/db/explain', payload);
    return data;
};
